import { axiosService } from 'ui-model';
// TODO pedro avoid importing from `@lumahealthhq/ui-model`
// eslint-disable-next-line no-restricted-imports
import { createQueryKey, useQuery } from '@lumahealthhq/ui-model';

export default function useFaxPdfById(
  { id }: { id: string },
  options?: {
    enabled?: boolean;
    onSuccess?: (blobUrl: string) => void;
    onError?: (error: unknown) => void;
    staleTime?: number;
    cacheTime?: number;
    keepPreviousData?: boolean;
  },
) {
  async function queryFn() {
    if (!id) return null;
    const url = `v2/fileUploads/${id}`;
    try {
      const response = await axiosService.get<ArrayBuffer>(url, {
        responseType: 'arraybuffer',
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);

      return blobUrl; // Return the Blob URL
    } catch (error) {
      return null;
    }
  }

  const queryKey = createQueryKey('fileUploads', 'v2/{basePath}/{id}', { id }, [id]);
  const query = useQuery(queryKey, queryFn, options);

  return query;
}
